(ns router.core
  (:import
   [goog.Uri QueryData])
  (:require [very.re-frame.core :as rf]
            [router.events]
            [camel-snake-kebab.core :as k]
            [cljs.spec.alpha :as s]
            [router.specs :as sp]
            [history.core :as history]))

(def route-table
  {:routes {:authenticated {:index {:redirects ["dashboard"]}

                            :dashboard {:on-enter [:boot-dashboard]}
                            :profile {:on-enter [:boot-client-profile]}
                            :accounts {:on-enter [:boot-client-accounts]}
                            :client-login {}
                            :onboard {:on-enter [:onboard/init]}

                            :login {:redirects ["dashboard"]}
                            :login.forgot {:redirects ["dashboard"]}
                            :login.reset {:redirects ["dashboard"]}
                            :login.mfa {:redirects ["dashboard"]}
                            :invite {:redirects ["dashboard"]}

                            :guidebook {:on-enter [:guidebook/fetch]}

                            :unauthenticated {:redirects ["dashboard"]}
                            :unavailable {:redirects ["dashboard"]}}
            :unauthenticated {:index {:redirects ["login"]}
                              :dashboard {:redirects ["unauthenticated"]}
                              :accounts {:redirects ["unauthenticated"]}
                              :client-login {:redirects ["unauthenticated"]}
                              :profile {:redirects ["unauthenticated"]}
                              :onboard {:on-enter [:onboard/unauthenticated]}

                              :guidebook {:redirects ["unauthenticated"]}

                              :login {:on-enter [:authentication/initialize-authentication]}
                              :login.forgot {:on-enter [:authentication/initialize-authentication]}
                              :login.reset {:on-enter [:authentication/initialize-authentication]}
                              :invite {:on-enter [[:authentication/initialize-authentication]
                                                  [:authentication/identify-session]]}
                              :unavailable {:on-enter [:service-error]}}}
   :current :authenticating})

(defn routes
  ([] (routes nil))
  ([x]
   {["login"] :login
    ["login" "forgot"] :login.forgot
    ["login" "reset" (last x)] :login.reset
    ["login" "mfa"] :login.mfa
    ["unauthenticated"] :unauthenticated

    ["personal-gameplan"] :guidebook

    ["advisor" (last x)] :impersonate.advisor
    ["personal-gameplan" (last x)] :impersonate.guidebook

    ["invite" (last x)] :invite
    ["onboard"] :onboard

    ["dashboard"] :dashboard
    ["accounts"] :accounts
    ["client-login"] :client-login
    ["profile"] :profile
    ["unavailable"] :unavailable
    [] :index}))

(defn path->route [x]
  (get (routes x) x))

(defn- route->cfg [rt auth route]
  (get-in rt [:routes auth route] {}))

(defn- redirect [{:keys [rt cfg params] :as all} auth]
  (if (:redirects cfg)
    (let [new-route (path->route (:redirects cfg))]
      {:rt rt
       :cfg (route->cfg rt auth new-route)
       :route new-route
       :paths (:redirects cfg)
       :params params})
    all))

(defn- current [{:keys [rt cfg route paths params]}]
  {:rt (assoc rt :current route)
   :cfg cfg
   :route route
   :paths paths
   :params params})

(defn- dispatch! [{:keys [cfg] :as all}]
  (when (:on-enter cfg)
    (doseq [evt (:on-enter cfg)]
      ;; allow :on-enter [:event] OR [[:event-a] [:event-b]]
      (if (sequential? evt)
        (rf/>evt evt)
        (rf/>evt [evt]))))
  all)

(defn- location->uri [paths params]
  (str "/" (clojure.string/join "/" paths)
       (when-not (empty? params)
         (str "?" (-> params
                      clj->js
                      (->> (.createFromMap QueryData))
                      .toDecodedString)))))

(defn- nav! [{:keys [paths params] :as all}]
  (history/nav! (location->uri paths params))
  all)

(defn- process! [auth route-table loc]
  (let [paths (:paths loc)
        params (:params loc)
        route (path->route paths)
        cfg (route->cfg route-table auth route)]
    ;; eject if the path doesnt exist
    (if (nil? cfg)
      (do
        (logging.core/error "Invalid route table path: " route))
      (-> {:rt route-table
           :cfg cfg
           :route route
           :paths paths
           :params params}
          (redirect auth)
          (current)
          (dispatch!)
          (nav!)))))

(defn parse-location [uri]
  (let [goog-uri (goog.Uri. uri)
        params (reduce (fn [acc key]
                         (assoc acc key (js->clj (.getParameterValues goog-uri key))))
                       {}
                       (.getKeys (.getQueryData goog-uri)))
        path (.getPath goog-uri)
        parts (vec (rest (clojure.string/split path #"/")))]
    {:current path
     :paths parts
     :params params}))

(defn- set-uri [db uri]
  (assoc db :uri uri))

(defn- set-route-table [db table]
  (assoc db :route-table table))

(defn- route-to-path [cfx [path]]
  (let [loc (parse-location path)
        auth (get (:db cfx) :authentication-status)
        {table :rt} (process! auth route-table loc)]
    {:db (-> (:db cfx)
             (set-uri loc)
             (set-route-table table))}))

(rf/reg-event-fx
 :router/route-to-path
 route-to-path)

(rf/reg-event-fx
 :router/html-navigation
 (fn [cfx [path]]
   {:nav! path}))

(def enabled? (atom true))

(defn nav-fx [route]
  (s/assert ::sp/routable-path route)
  (if @enabled?
    (condp = route
      :kill
      (do
        (history/kill)
        (reset! enabled? false))

      (rf/>evt [:router/route-to-path route]))

    (logging.core/warn "Routing has been disabled.")))

(defn redirect-fx [url]
  (set! (.-location js/window) url))

(rf/reg-sub
 :route-table
 (fn [db]
   (:route-table db)))

(rf/reg-sub
 :route
 :<- [:route-table]
 (fn [table]
   (:current table)))

(rf/reg-sub
 :uri
 (fn [db]
   (:uri db)))
